import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { multiLanguage } from "../../hoc";
// import { assetsPath } from "../../utils";

@multiLanguage()
export default class Welcome extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  renderItem = () => {
    const { content, t } = this.props;
    return _.map(content, item => {
      console.log('item >>> ', item);
      return (
        <div className="item">
          <img style={{ height: 225 }} src={item.image} alt="" />
          <h2 dangerouslySetInnerHTML={{ __html: t(item.text) }} />
          <h3 dangerouslySetInnerHTML={{ __html: t(item.date) }} />
        </div>
      )
    })
  }
  render() {
    const { page, t, title, content, button } = this.props;
    // console.log('page welcome >>>> ', page);
    // button={_.get(pageData, "button")}
    return (
      <div className="section-home-promotion">
        <div className="content-home-promotion">
          <h1 dangerouslySetInnerHTML={{ __html: t(title) }} />
          <div className="line" />
          <div className="item-container">
            {this.renderItem()}
          </div>
          <a href="https://lagunaproperty.com/en/news/"><h3 dangerouslySetInnerHTML={{ __html: t(button) }} /></a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Promotion.js